/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('Units', function ($scope, $http, $stateParams, $location, $mdToast, _$breadcrumbs,$rootScope) {
    $scope.action = false;
    $scope.unit = {
        subunit: false
    };

    $scope.delete = function (id) {
        var promise = $http.get('/administration/unit/delete/' + id);        
        promise.then(
                function (payload) {                    
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent(payload.data.msg)
                            .position('top right')
                            .hideDelay(3000)
                            );
                    if (payload.data.code) {
                        $scope.getList();
                    }
                });                
    };

    $scope.showLoader = false;
    $scope.getList = function () {
        $scope.showLoader = true;
        $http.post('/administration/unit/getlist', {subunit: $scope.unit.subunit})
                .success(function (list) {
                    $scope.showLoader = false;
                    $scope.units = list;
                });
    };

    $scope.edit = function (unit) {
        $location.path('/app/administration/unit/' + (unit.subunit ? 'subunit' : 'unit') + '/edit/' + unit.id);
    };

    $scope.check = function (form) {            
        if (form.$valid) {
            $scope.save();
        } else {
            angular.forEach(form.$error, function (field) {
                angular.forEach(field, function (f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.save = function () {        
        $http.post('/administration/unit/save', $scope.unit)
                .success(function (result) {
                    var msg = ($scope.unit.subunit ? 'Jednostka została zapisana' : 'Wydział został zapisany');
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent(msg)
                            .position('top right')
                            .hideDelay(3000)
                            );
                    $location.path('/app/administration/unit/' + ($scope.unit.subunit ? 'subunit' : ''));
                });
    };

    $scope._init = function () {
        if ($stateParams.type == 'unit') {
            $scope.unit.subunit = false;
        } else if ($stateParams.type == 'subunit') {
            $scope.unit.subunit = true;
        }

        if (!_.isUndefined($stateParams.action)) {
            $scope.action = $stateParams.action;

            if ($stateParams.type == 'unit') {
                _$breadcrumbs.push($scope.action == 'new' ? 'Nowa wydział' : 'Edycja wydziału');
            } else if ($stateParams.type == 'subunit') {
                _$breadcrumbs.push($scope.action == 'new' ? 'Nowa jednostka' : 'Edycja jednostki');
            }

            if ($stateParams.action == 'edit') {
                if (_.isUndefined($stateParams.id)) {
                    $location.path('/app/administration/unit' + ($scope.unit.subunit ? '/subunit' : ''));
                }
                $http.get('/administration/unit/getunit/' + $stateParams.id)
                        .success(function (unit) {
                            unit.subunit = unit.subunit == 1;
                            $scope.unit = unit;
                        });
            }
        }

        if (_.isUndefined($stateParams.action)) {
            $scope.getList();
        }
    };
    $scope._init();
});
                  